import { useState } from 'react';
import styles from '../scss/code.module.scss';
import useConfig from '@@/use-config';
import { InjectedCompProps, useAsyncEffect } from 'topwrite';

function getLanguage(className: string[]) {
    return className
    .map(function(cl) {
        // Markdown
        if (cl.search('lang-') === 0) {
            return cl.slice('lang-'.length);
        }

        // Asciidoc
        if (cl.search('language-') === 0) {
            return cl.slice('language-'.length);
        }

        return null;
    })
    .find(function(cl) {
        return Boolean(cl);
    });
}

async function loadPrism() {
    const Prism = await import('prismjs');
    await import('prismjs/components/prism-sql');
    return Prism;
}

interface CodeProps {
    children: string[];
    className?: string[];
}

export default function Code({ props: { children: codes, className }, children }: InjectedCompProps<CodeProps>) {

    const config = useConfig();

    const [html, setHtml] = useState<string | null>(null);
    const [key, setKey] = useState(() => (new Date()).toISOString());

    useAsyncEffect(async () => {
        const content = codes.join('');
        if (content.match(/\n/)) {
            const Prism = await loadPrism();
            //单行不高亮
            try {

                let lang = getLanguage(className || []);

                if (!lang) {
                    lang = config.getValue('defaultLanguage', 'clike');
                }

                let html: string;
                if (!Prism.languages[lang]) {
                    lang = 'clike';
                }

                html = Prism.highlight(content, Prism.languages[lang], lang);

                setHtml(html);
                setKey((new Date()).toISOString());
            } catch (e) {
                console.error(e);
            }
        }

    }, [codes]);

    if (!html) {
        return children;
    }

    return <code key={key} className={styles.container} dangerouslySetInnerHTML={{ __html: html }} />;
}
